'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('../../../components');

var _components2 = _interopRequireDefault(_components);

var _Paper = require('material-ui/Paper');

var _Paper2 = _interopRequireDefault(_Paper);

var _ListView = require('../../../components/public/Connectors/Connector/ListView');

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _ContentCopy = require('material-ui-icons/ContentCopy');

var _ContentCopy2 = _interopRequireDefault(_ContentCopy);

var _Delete = require('material-ui-icons/Delete');

var _Delete2 = _interopRequireDefault(_Delete);

var _Link = require('material-ui-icons/Link');

var _Link2 = _interopRequireDefault(_Link);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TemplateWrapper = (_temp = _class = function (_EditorComponent) {
  _inherits(TemplateWrapper, _EditorComponent);

  function TemplateWrapper() {
    _classCallCheck(this, TemplateWrapper);

    return _possibleConstructorReturn(this, _EditorComponent.apply(this, arguments));
  }

  TemplateWrapper.prototype.renderPanelView = function renderPanelView() {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, _react2.default.createElement('div', {
      className: classes.panelButton
    }, 'TemplateWrapper'));
  };

  TemplateWrapper.prototype.renderMainView = function renderMainView() {
    var _this2 = this;

    var _context = this.context,
        Grid = _context.Grid,
        Link = _context.Link;
    var FrontEditor = this.props.FrontEditor;

    var _getEditorContext2 = this.getEditorContext(),
        classes = _getEditorContext2.classes;

    return _react2.default.createElement(_ListView.ObjectContext.Consumer, null, function (context) {
      var object = context.object;

      if (!object) {
        return null;
      }

      {
        /* let {
          id,
          externalKey,
          createdAt,
          updatedAt,
          rank,
          ...newObject
         } = object; */
      }
      var objectId = object.id,
          name = object.name,
          component = object.component,
          description = object.description;
      return _react2.default.createElement(_Paper2.default, {
        style: {
          cursor: "pointer",
          padding: 10,
          margin: "10px 0",
          width: "100%"
        },
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();

          _this2.insertComponent(object);
        }
      }, _react2.default.createElement(Grid, {
        container: true,
        spacing: 0
      }, _react2.default.createElement(Grid, {
        item: true
      }, name), component !== name ? _react2.default.createElement(Grid, {
        item: true
      }, '/ ', component) : null, _react2.default.createElement(Grid, {
        item: true,
        xs: true
      }), description ? _react2.default.createElement(Grid, {
        item: true,
        xs: 12
      }, _react2.default.createElement(_Typography2.default, {
        variant: 'caption'
      }, description)) : null, objectId ? _react2.default.createElement(Grid, {
        item: true
      }, _react2.default.createElement(Link, {
        to: '/templates/' + objectId,
        onClick: function onClick(event) {
          event.stopPropagation();
        }
      }, _react2.default.createElement(_Link2.default, null))) : null, _react2.default.createElement(Grid, {
        item: true
      }, _react2.default.createElement(_IconButton2.default, {
        className: classes.badgeButton,
        title: 'Insert with ID',
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();

          _this2.insertComponent(object, true);
        }
      }, _react2.default.createElement(_ContentCopy2.default, null))), _react2.default.createElement(Grid, {
        item: true
      }, _react2.default.createElement(_IconButton2.default, {
        className: classes.badgeButton,
        title: 'Delete template',
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();

          _this2.deleteTemplate(object);
        }
      }, _react2.default.createElement(_Delete2.default, null)))), _react2.default.createElement('hr', null), _react2.default.createElement(FrontEditor, {
        data: {
          object: object
        },
        style: {
          maxHeight: 350,
          overflow: "auto"
        }
      }));
    });
  };

  TemplateWrapper.prototype.insertComponent = function insertComponent(object) {
    var withID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var activeItem = this.props.activeItem;
    var id = object.id,
        name = object.name,
        description = object.description,
        props = object.props,
        component = object.component,
        components = object.components,
        Parent = object.Parent;
    var newObject = {
      name: name,
      description: description,
      props: props,
      component: component,
      components: components,
      Parent: Parent
    };

    if (withID) {
      Object.assign(newObject, {
        id: id
      });
    }

    newObject = JSON.parse(JSON.stringify(newObject)); // alert("Sdfsdfs");

    if (activeItem) {
      activeItem.addComponent(newObject);
    }
  };

  TemplateWrapper.prototype.deleteTemplate = function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee(object) {
      var templateId, _deleteTemplate;

      return _regenerator2.default.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              templateId = object.id;

              if (window.confirm("Delete this template?")) {
                _deleteTemplate = this.context.query.deleteTemplate;
                this.mutate({
                  mutation: (0, _graphqlTag2.default)(_deleteTemplate),
                  variables: {
                    where: {
                      id: templateId
                    }
                  }
                });
              }

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee, this);
    }));

    function deleteTemplate(_x2) {
      return _ref.apply(this, arguments);
    }

    return deleteTemplate;
  }();

  return TemplateWrapper;
}(_components2.default), _class.Name = "TemplateWrapper", _temp);
exports.default = TemplateWrapper;
module.exports = exports['default'];